import React, { useState, useEffect, useContext } from "react";

import { Row, Col } from "antd";
import { stringify, parse } from "svgson";
import TopBar from "./components/TopBar";
import Canvas from "./components/Canvas";
import { AppContext } from "../../index";

const SvgEditor = () => {
const {svgString, setSvgString} = useContext(AppContext);
  const [svg, setSvg] = useState();
  const [svgJoined, setSvgJoined] = useState();
  const [mouseMode, setMouseMode] = useState("delete"); // integer state
  const [zoomValue, setZoomValue] = useState(100); // integer state
  const [isCanvasDisabled, setIsCanvasDisabled] = useState(false); // integer state
  const [cursor, setCursor] = useState(`crosshair`);

  const [svgHistory, setSvgHistory] = useState(new Array(50));
  const [historyIndex, setHistoryIndex] = useState(0);

  const [undoActions, setUndoActions] = useState(0);
  const [redoActions, setRedoActions] = useState(0);

  // useeffect for props.rawSvg
  useEffect(() => {
    // parse props.rawSvg
    parse(svgString).then((svg) => {
      updateSvg(svg);
    });
  }, [svgString]);

  // write a function calles joinSVG that does the opposite of splitSVG
  const updateSVGJoined = (split) => {
    // initialize an array of "" with length of join.children.length
    console.log("split", split);
    var joinedPaths = Array(split.children.length).fill("");
    for (var i = 0; i < split.children.length; i++) {
      for (var j = 0; j < split.children[i].children.length; j++) {
        joinedPaths[i] += split.children[i].children[j].attributes.d;
      }
    }
    let joined = JSON.parse(JSON.stringify(split));
    console.log("joined", joined);
    // for each child in joined.children[i]
    for (var i = 0; i < joined.children.length; i++) {
      // update path with new attributes.d
      joined.children[i].attributes.d = joinedPaths[i];
      joined.children[i].children = [];
    }
    setSvgJoined(joined);
  };

  const updateSvg = (newSvg) => {
    console.log(
      "undo, redo, history index: ",
      undoActions,
      redoActions,
      historyIndex
    );
    setUndoActions(undoActions + 1);
    setRedoActions(0);
    let items = Object.assign({}, svgHistory);
    // Make a shallow copy of the item you want to mutate
    let item = JSON.parse(JSON.stringify(newSvg));
    //Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
    items[historyIndex] = item;
    //Set the state to our new copy
    setHistoryIndex((historyIndex + 1) % 50);
    setSvgHistory(items);
    setSvg(newSvg);
    console.log("newSvg", newSvg);
    updateSVGJoined(newSvg);
  };

  return (
    <div>
      <Col style={{ marginTop: "10px", outline: "1px solid #f0f0f0" }}>
        <Row style={{ backgroundColor: "#d0d0d0", padding:"5px"}}>
          {/* pass in setSvg, svgJoined, setMouseMode, setZoomValue, setCursor, svgHistory, historyIndex, setHistoryIndex, undoActions, setUndoActions, redoActions, setRedoActions, updateSVGJoined, zoomValue as props into TopBar */}
            <TopBar
                setSvg={setSvg}
                svgJoined={svgJoined}
                setMouseMode={setMouseMode}
                setZoomValue={setZoomValue}
                setCursor={setCursor}
                svgHistory={svgHistory}
                historyIndex={historyIndex}
                setHistoryIndex={setHistoryIndex}
                undoActions={undoActions}
                setUndoActions={setUndoActions}
                redoActions={redoActions}
                setRedoActions={setRedoActions}
                updateSVGJoined={updateSVGJoined}
                zoomValue={zoomValue}
            />
        </Row>
<Row>
        <Col
          flex="auto"
          style={{
            backgroundColor: "#f0f0f0",
            height: "calc(100vh)",
            overflowX: "scroll",
            maxWidth: "calc(100vw - 320px)",
            cursor: cursor,
          }}
        >
          <center>
            <Canvas
              isCanvasDisabled={isCanvasDisabled}
              svg={svg}
              svgJoined={svgJoined}
              setSvgJoined={setSvgJoined}
              mouseMode={mouseMode}
              zoomValue={zoomValue}
              setSvg={updateSvg}
            />
          </center>
        </Col>
        <Col
                flex="auto"
      style={{

            height: "calc(100vh)",
            width: "200px",
            backgroundColor: "#e1e1e1",
          }}
          >
            test
          </Col>
          </Row>
      </Col>
     
    </div>
  );
};

export default SvgEditor;
